"use client";

import { RiMicLine } from "@remixicon/react";
import type { ArtistSearchResult } from "@workspace/types";
import { cn } from "@workspace/ui/lib/utils";
import Image from "next/image";

export interface ArtistResultProps {
	artist: ArtistSearchResult;
	isSelected: boolean;
	onSelect: () => void;
}

export function ArtistResult({
	artist,
	isSelected,
	onSelect,
}: ArtistResultProps) {
	return (
		<button
			type="button"
			className={cn(
				"relative flex w-full items-center gap-3 rounded-lg p-3 text-left transition-colors",
				isSelected ? "bg-muted" : "hover:bg-muted",
			)}
			onClick={onSelect}
			aria-label={
				artist.name +
				(artist.is_collaborative_alias ? " (collaborative alias)" : "")
			}
		>
			{artist.image_url ? (
				<Image
					src={artist.image_url}
					alt={artist.name}
					width={40}
					height={40}
					className="h-10 w-10 flex-shrink-0 rounded-md object-cover"
				/>
			) : (
				<div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-md bg-muted">
					<RiMicLine className="h-5 w-5 text-muted-foreground" />
				</div>
			)}
			<div className="flex min-w-0 flex-1 flex-col">
				<span className="truncate font-medium text-sm">{artist.name}</span>
				{artist.is_collaborative_alias &&
					(artist.primary_artist_name || artist.collaborator_names?.length) && (
						<span className="text-muted-foreground text-xs">
							{artist.primary_artist_name && artist.collaborator_names?.length
								? `${artist.primary_artist_name} & ${artist.collaborator_names.join(" & ")}`
								: artist.primary_artist_name ||
									artist.collaborator_names?.join(" & ")}
						</span>
					)}
			</div>
		</button>
	);
}
